import { CssBaseline, ThemeProvider } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { ThemeSettings } from './theme/Theme';
import RTL from './layouts/full/shared/customizer/RTL';
import ScrollToTop from './components/shared/ScrollToTop';
import Router from './routes/Router';
import { it, enUS } from 'date-fns/locale'
import { useState, useEffect } from 'react';
// LOGIN RELATED 

import { MsalProvider, useMsal } from '@azure/msal-react';
import {setDefaultOptions} from "date-fns";
import PrivacyPolicyModal from './components/privacy/PrivacyPolicyModal';
import  './components/privacy/privacy.css';



//END LOGIN
const App = ({ instance }) => {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  if (navigator.language === 'it-IT') {
    setDefaultOptions({locale: it})
  } else {
    setDefaultOptions({locale: enUS})
  }

  useEffect(() => {
    // Check if user is logged in and hasn't accepted privacy policy
    if (instance.getActiveAccount() && customizer.userName?.TermsAndPrivacyAccepted === false) {
      setShowPrivacyPolicy(true);
    }else{
      setShowPrivacyPolicy(false);
    }
  }, [instance, customizer.userName, customizer]);
  const handleDecline = () => {
    // Perform logout
    instance.logoutRedirect()
      .catch(e => {
        console.error("Logout failed", e);
      });
  };
  return (
    <MsalProvider instance={instance}>
      <ThemeProvider theme={theme}>
        <RTL direction={customizer.activeDir}>
          <CssBaseline />
          {/* Only show app content if privacy policy is accepted or there's no active account */}
          <div className={showPrivacyPolicy ? 'content-blur' : ''}>
              <ScrollToTop>{routing}</ScrollToTop>
          </div>
          <PrivacyPolicyModal
            open={showPrivacyPolicy}
            onClose={() => setShowPrivacyPolicy(false)}
            onDecline={handleDecline}
            userId={customizer.userName?.UserId || null}
          />
        </RTL>
      </ThemeProvider>
    </MsalProvider>
  );
};

export default App;
